import '../../../styles/knowledge-concept/TopicCard.css';
import 'react-circular-progressbar/dist/styles.css';

import { Box, Card, CardContent, Typography } from '@mui/material';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import Label from '../../atoms/Label';
import React from 'react';

const TopicCard = ({ progress, title, color }) => {
	return (
		<Card
			sx={{
				display: 'flex',
				minWidth: '14rem',
				maxWidth: '14rem',
				padding: '0.35rem',
				minHeight: '6.45rem',
				boxShadow: '4px 7px 4px 0px rgba(0, 0, 0, 0.25)',
				border: '1px solid rgb(129, 129, 129)',
			}}
		>
			<CardContent
				sx={{
					flex: '1 0 auto',
					width: '60%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '0',
				}}
			>
				<Typography
					variant="boddy"
					gutterBottom
					sx={{
						width: '100%',
						display: 'block',
						fontFamily: 'Helvetica',
						fontSize: '1rem',
						fontWeight: 'bold',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'wrap',
						textAlign: 'start',
					}}
				>
					{title || 'Topic Name'}
				</Typography>
			</CardContent>
			<Box
				sx={{
					width: '40%',
					height: 'auto',
					alignItems: 'center',
					display: 'flex',
					justifyContent: 'center',
				}}
			>
				<CircularProgressbar
					value={progress}
					text={`${progress}%`}
					strokeWidth={15}
					styles={buildStyles({
						//pathColor: progress === 100 ? 'green' : progress > 60 ? '#48b7ff' : 'red',
						pathColor: color,
						textColor: 'black',
					})}
				/>
			</Box>
		</Card>
	);
	// return (
	// 	<div className="topic-card">
	// 		{/* <Label
	//     label={title || "Topic Name"}
	//     fontSize="16px"
	//     fontWeight="400px"
	//   /> */}
	// 		<Box
	// 			sx={{
	// 				display: 'flex',
	// 				minHeight: '2rem',
	// 				alignItems: 'center',
	// 				minWidth: '10.5rem',
	// 				maxWidth: '10.5rem',
	// 				padding: '0.25rem',
	// 				whiteSpace: 'wrap',
	// 			}}
	// 		>
	// 			<Typography
	// 				variant="boddy"
	// 				gutterBottom
	// 				sx={{
	// 					display: 'block',
	// 					fontFamily: 'Helvetica',
	// 					fontSize: '1rem',
	// 					// overflow: "hidden",
	// 					textOverflow: 'ellipsis',
	// 					whiteSpace: 'wrap',
	// 				}}
	// 			>
	// 				{title || 'Topic Name'}
	// 			</Typography>
	// 		</Box>
	// 		<span>{progress}%</span>
	// 		<div className="progress-bar">
	// 			<div
	// 				className={`progress-bar-fill ${
	// 					progress === 100 ? 'green' : progress > 60 ? 'blue' : 'red'
	// 				}`}
	// 				style={{ width: `${progress}%` }}
	// 			></div>
	// 		</div>
	// 	</div>
	// );
};

export default TopicCard;
